import JsBarcode from "jsbarcode";
import { apiBaseUrl } from "./create/api.js";
import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";
import {
	formatFaturaAmount,
	formatFaturaQuantityDisplay,
	normalizeFaturaCurrency,
	parseFaturaQuantity,
} from "./faturaCurrency.js";
import { AMORTISMAN_STATUS_LABELS } from "../../amortisman/amortismanUtils.js";
import { uiState } from "../../../state/uiState.js";

const tl = new Intl.NumberFormat("tr-TR", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const USEFUL_LIFE_MOVEMENT_LABELS = {
	baslangic_migrasyonu: "Takip ba\u015flang\u0131\u00e7 migration'\u0131",
	ilk_tanim: "\u0130lk faydal\u0131 \u00f6m\u00fcr se\u00e7imi kaydedildi",
	tanim_guncelleme: "Faydal\u0131 \u00f6m\u00fcr tan\u0131m\u0131 g\u00fcncellendi",
	inceleme_notu: "\u0130nceleme notu eklendi",
	kullanima_devam: "Kullan\u0131ma devam karar\u0131",
	bakim_tamir_sonrasi_devam: "Bak\u0131m/tamir sonras\u0131 devam karar\u0131",
	sure_revizyonu: "Faydal\u0131 \u00f6m\u00fcr d\u00f6nem s\u00fcresi revize edildi",
	takip_arsivleme: "Faydal\u0131 \u00f6m\u00fcr takibi ar\u015fivlendi",
};

function esc(value) {
	return String(value ?? "")
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;");
}

function ensureOverviewDialog() {
	if (document.getElementById("overviewDialog")) return;
	document.body.insertAdjacentHTML(
		"beforeend",
		`
<dialog id="overviewDialog">
	<div class="edit-loading-overlay" hidden>
		<div class="edit-loading-spinner"></div>
		<span class="edit-loading-text">Yukleniyor...</span>
	</div>
	<div class="overview-container">
		<div class="overview-header">
			<div class="overview-header-text">
				<h2 class="overview-title"></h2>
				<span class="overview-id"></span>
				<span class="overview-temsil-toplam"></span>
				<div class="overview-badges">
					<span class="overview-badge-urun-durumu"></span>
					<span class="overview-badge-zimmet-durumu"></span>
				</div>
			</div>
			<div class="overview-header-actions">
				<div class="overview-action-menu-wrap">
					<button class="overview-actions-toggle" type="button" aria-expanded="false" aria-label="\u0130\u015flemler" title="\u0130\u015flemler">
						<span class="material-icons" aria-hidden="true">more_horiz</span>
					</button>
					<div class="overview-action-menu" hidden>
						<button class="overview-events-open overview-history-action" type="button"><span class="material-icons">history</span>Olaylari Goruntule</button>
						<button class="overview-export" type="button"><span class="material-icons">description</span>TXT Indir</button>
						<button class="overview-archives-open overview-history-action" type="button"><span class="material-icons">inventory_2</span>Arsivlenen Alim Partileri</button>
					</div>
				</div>
				<button class="overview-close" type="button">&#10005;</button>
			</div>
		</div>
		<div class="overview-body">
			<div class="overview-top">
				<div class="overview-image-box">
					<img class="overview-product-img" alt="" hidden />
					<div class="overview-image-placeholder" hidden>
						<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
							<rect x="2" y="3" width="20" height="14" rx="2" />
							<line x1="8" y1="21" x2="16" y2="21" />
							<line x1="12" y1="17" x2="12" y2="21" />
						</svg>
						<span>Gorsel yok</span>
					</div>
				</div>
				<div class="overview-barcode-box">
					<span class="overview-barcode-label">Barkod</span>
					<svg id="overview-barcode-svg"></svg>
					<span class="overview-barcode-value"></span>
				</div>
			</div>
			<div class="overview-section">
				<div class="overview-section-header">Urun Bilgileri</div>
				<div class="overview-section-body overview-grid-4"></div>
			</div>
			<div class="overview-section">
				<div class="overview-section-header overview-section-header--slate">
					Alim Partileri / Faturalar (<span class="overview-fatura-count">0</span> Kayit)
				</div>
				<div class="overview-section-body overview-fatura-list"></div>
				<div class="overview-fatura-total" hidden>
					<span class="overview-total-label">Toplam Satin Alma Degeri</span>
					<span class="overview-total-value"></span>
				</div>
			</div>
			<div class="overview-section">
				<div class="overview-section-header overview-section-header--gold">Zimmet Bilgileri</div>
				<div class="overview-section-body overview-grid-3"></div>
			</div>
			<div class="overview-section">
				<div class="overview-section-header overview-section-header--silver">Lokasyon</div>
				<div class="overview-section-body overview-grid-3"></div>
			</div>
			<div class="overview-section">
				<div class="overview-section-header overview-section-header--muted">Sistem Bilgileri</div>
				<div class="overview-section-body overview-grid-4"></div>
			</div>
		</div>
		<div class="overview-footer">
			<button class="overview-close-btn">Kapat</button>
		</div>
	</div>
</dialog>
<dialog id="overviewEventsDialog" class="overview-subdialog">
	<div class="overview-subdialog-header"><div><h3>Demirbas Olaylari</h3><span class="overview-events-context"></span></div><button type="button" class="overview-subdialog-close">&#10005;</button></div>
	<div class="overview-event-filters">
		<button type="button" class="is-active" data-event-category="all">Tumu</button>
		<button type="button" data-event-category="demirbas">Demirbas</button>
		<button type="button" data-event-category="alim_partileri">Alim Partileri</button>
		<button type="button" data-event-category="faydali_omur">Faydali Omur</button>
		<button type="button" data-event-category="arsiv">Arsiv</button>
	</div>
	<div class="overview-event-list"></div>
</dialog>
<dialog id="overviewArchivesDialog" class="overview-subdialog">
	<div class="overview-subdialog-header"><div><h3>Arsivlenen Alim Partileri</h3><span class="overview-archives-context"></span></div><button type="button" class="overview-subdialog-close">&#10005;</button></div>
	<div class="overview-archive-list"></div>
</dialog>
<dialog id="overviewLotArchiveDialog" class="overview-subdialog overview-confirm-dialog">
	<form class="overview-lot-archive-form">
		<div class="overview-subdialog-header"><div><h3>Alim Partisini Arsivle</h3><span class="overview-lot-archive-context"></span></div><button type="button" class="overview-subdialog-close">&#10005;</button></div>
		<p>Bu islem geri alinamaz. PDF ve olay gecmisi korunur.</p>
		<label>Arsiv Notu<textarea class="overview-lot-archive-note" maxlength="1000" required></textarea></label>
		<div class="overview-lot-archive-error"></div>
		<div class="overview-confirm-actions"><button type="button" class="overview-subdialog-close">Iptal</button><button type="submit">Arsivle</button></div>
	</form>
</dialog>
<dialog id="overviewArchivePrerequisiteDialog" class="overview-subdialog overview-prerequisite-dialog" aria-labelledby="overviewArchivePrerequisiteTitle">
	<div class="overview-subdialog-header overview-prerequisite-header">
		<span class="material-icons" aria-hidden="true">priority_high</span>
		<div>
			<h3 id="overviewArchivePrerequisiteTitle">Al&#305;m Partisi Hen&#252;z Ar&#351;ivlenemez</h3>
			<span>Ar&#351;ivleme s&#305;ras&#305; tamamlanmal&#305;d&#305;r.</span>
		</div>
	</div>
	<div class="overview-prerequisite-body">
		<p>Al&#305;m partisi ar&#351;ivlenmeden &#246;nce ona ba&#287;l&#305; faydal&#305; &#246;m&#252;r takibi ar&#351;ivlenmelidir.</p>
		<div class="overview-prerequisite-records">
			<div><span>Al&#305;m Partisi</span><strong class="overview-prerequisite-lot-id"></strong></div>
			<div><span>Faydal&#305; &#214;m&#252;r Takibi</span><strong class="overview-prerequisite-tracking-id"></strong></div>
		</div>
		<p class="overview-prerequisite-guidance">Amortisman Takibi ekran&#305;ndan belirtilen takip kayd&#305;n&#305; ar&#351;ivledikten sonra bu i&#351;lemi tekrar deneyin.</p>
	</div>
	<div class="overview-prerequisite-actions">
		<button type="button" class="overview-prerequisite-confirm">Tamam</button>
	</div>
</dialog>`,
	);
	const prerequisiteDialog = document.getElementById("overviewArchivePrerequisiteDialog");
	prerequisiteDialog?.addEventListener("cancel", (event) => event.preventDefault());
}

function formatDate(val, withTime = false) {
	if (!val) return "-";
	if (!withTime && typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
		const [year, month, day] = val.split("-");
		return `${day}.${month}.${year}`;
	}
	const date = new Date(val);
	if (Number.isNaN(date.getTime())) return String(val);
	const dateText = date.toLocaleDateString("tr-TR");
	return withTime
		? `${dateText} ${date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}`
		: dateText;
}

function valueText(value) {
	if (value === null || value === undefined || value === "") return "-";
	return String(value);
}

function buildTotalsByCurrency(faturalar = []) {
	const totalsByCurrency = new Map();
	faturalar.forEach((fatura) => {
		const currencyCode = normalizeFaturaCurrency(fatura?.para_birimi);
		const currentTotal = totalsByCurrency.get(currencyCode) ?? 0;
		totalsByCurrency.set(currencyCode, currentTotal + Number(fatura?.satin_alma_degeri ?? 0));
	});
	return totalsByCurrency;
}

function buildTotalQuantity(faturalar = []) {
	return faturalar.reduce((sum, fatura) => {
		const parsed = parseFaturaQuantity(fatura?.birim_miktar);
		return sum + (parsed ?? 0);
	}, 0);
}

function downloadTextFile(filename, content) {
	const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	link.remove();
	URL.revokeObjectURL(url);
}

function formatExportFileDate(date = new Date()) {
	const parts = [
		date.getFullYear(),
		String(date.getMonth() + 1).padStart(2, "0"),
		String(date.getDate()).padStart(2, "0"),
	].join("-");
	const time = [
		String(date.getHours()).padStart(2, "0"),
		String(date.getMinutes()).padStart(2, "0"),
	].join("-");
	return `${parts}-${time}`;
}

function pushSection(lines, title, rows) {
	lines.push(`[${title}]`);
	rows.forEach(([label, value]) => {
		lines.push(`${label}: ${valueText(value)}`);
	});
	lines.push("");
}

function buildOverviewExportText(data) {
	const faturalar = Array.isArray(data?.faturalar) ? data.faturalar : [];
	const archivedInvoices = Array.isArray(data?.arsivlenmis_faturalar) ? data.arsivlenmis_faturalar : [];
	const now = new Date();
	const totalsByCurrency = buildTotalsByCurrency(faturalar);
	const lines = [
		"Demirbas Overview Export",
		`Demirbas ID: ${valueText(data?.demirbas_id)}`,
		`Indirme Tarihi: ${formatDate(now, true)}`,
		"",
	];

	pushSection(lines, "Urun Bilgileri", [
		["Demirbas ID", data?.demirbas_id],
		["Departman", data?.departman],
		["Urun Grubu", data?.urun_grubu],
		["Urun Alt Grubu", data?.urun_alt_grubu],
		["Urun Cinsi", data?.urun_cinsi],
		["Marka", data?.marka],
		["Model", data?.model],
		["Marka / Model", [data?.marka, data?.model].filter(Boolean).join(" / ") || "-"],
		["Seri No", data?.seri_numarasi],
		["Barkod", data?.barkod],
		["Urun Durumu", data?.urun_durumu],
		["Zimmet Durumu", data?.zimmet_durumu],
		["Aciklama", data?.aciklama],
	]);

	pushSection(lines, "Zimmet Bilgileri", [
		["Personel", data?.zimmetlenen_kisi],
		["TC Kimlik No", data?.zimmetlenen_tc],
		["Zimmet Tarihi", formatDate(data?.zimmet_tarihi)],
	]);

	pushSection(lines, "Lokasyon", [
		["Lokasyon", data?.lokasyon],
		["Oda", data?.oda],
		["Yer", data?.yer],
	]);

	pushSection(lines, "Sistem Bilgileri", [
		["Olusturan", data?.olusturan_kullanici],
		["Olusturma Tarihi", formatDate(data?.olusturma_tarihi, true)],
		["Son Guncelleyen", data?.son_guncelleyen_kullanici],
		["Son Guncelleme", formatDate(data?.son_guncelleme_tarihi, true)],
	]);

	lines.push("[Fatura Paketi]");
	lines.push(`Fatura Sayisi: ${faturalar.length}`);
	if (!faturalar.length) {
		lines.push("Fatura: -");
	} else {
		faturalar.forEach((fatura, index) => {
			const currencyCode = normalizeFaturaCurrency(fatura?.para_birimi);
			lines.push(`Fatura ${index + 1}`);
			lines.push(`Fatura Numarasi: ${valueText(fatura?.fatura_numarasi)}`);
			lines.push(`Takip ID: ${valueText(fatura?.takip_id)}`);
			lines.push(`Donem Tipi: ${valueText(fatura?.donem_tipi)}`);
			lines.push(`Guncel Baslangic: ${formatDate(fatura?.amortisman_baslangic_tarihi)}`);
			lines.push(`Satin Alma Tarihi: ${formatDate(fatura?.satin_alma_tarihi)}`);
			lines.push(`Faydali Omur Tanimi: ${valueText(fatura?.amortisman_tanim_adi)}`);
			lines.push(`Faydali Omur: ${fatura?.faydali_omur_yil ? `${fatura.faydali_omur_yil} yil` : "-"}`);
			lines.push(`Tahmini Bitis: ${formatDate(fatura?.amortisman_bitis_tarihi)}`);
			lines.push(`Faydali Omur Durumu: ${AMORTISMAN_STATUS_LABELS[fatura?.amortisman_durumu] || "-"}`);
			lines.push(`Hareket Sayisi: ${valueText(fatura?.hareket_sayisi)}`);
			lines.push(`Son Hareket: ${USEFUL_LIFE_MOVEMENT_LABELS[fatura?.son_hareket] || valueText(fatura?.son_hareket)}`);
			lines.push(`Para Birimi: ${currencyCode}`);
			lines.push(`Birim Fiyat: ${fatura?.birim_fiyat != null ? formatFaturaAmount(tl, fatura.birim_fiyat, currencyCode) : "-"}`);
			lines.push(`Temsil Adedi: ${formatFaturaQuantityDisplay(fatura?.birim_miktar, "-")}`);
			lines.push(`KDV Orani: ${fatura?.kdv_orani != null ? `%${fatura.kdv_orani}` : "-"}`);
			lines.push(`KDV Tutari: ${fatura?.kdv_tutar != null ? formatFaturaAmount(tl, fatura.kdv_tutar, currencyCode) : "-"}`);
			lines.push(`Satin Alma Degeri: ${fatura?.satin_alma_degeri != null ? formatFaturaAmount(tl, fatura.satin_alma_degeri, currencyCode) : "-"}`);
			lines.push(`Fatura Aciklamasi: ${valueText(fatura?.fatura_aciklama)}`);
			lines.push(`Takip Arsivli: ${fatura?.takip_arsivli ? "Evet" : "Hayir"}`);
			lines.push(`Takip Arsiv Tarihi: ${formatDate(fatura?.takip_arsiv_tarihi, true)}`);
			lines.push(`Takip Arsiv Notu: ${valueText(fatura?.takip_arsiv_notu)}`);
			lines.push(`Alim Partisi Arsivli: Hayir`);
			lines.push("");
		});
	}

	lines.push("[Arsivlenen Alim Partileri]");
	lines.push(`Arsivlenen Kayit Sayisi: ${archivedInvoices.length}`);
	archivedInvoices.forEach((fatura, index) => {
		lines.push(`Arsiv ${index + 1}: #${valueText(fatura.fatura_id)} / ${valueText(fatura.fatura_numarasi)}`);
		lines.push(`Takip ID: ${valueText(fatura.takip_id)}`);
		lines.push(`Takip Arsivli: ${fatura?.takip_arsivli ? "Evet" : "Hayir"}`);
		lines.push(`Takip Arsiv Tarihi: ${formatDate(fatura?.takip_arsiv_tarihi, true)}`);
		lines.push(`Takip Arsiv Notu: ${valueText(fatura?.takip_arsiv_notu)}`);
		lines.push(`Hareket Sayisi: ${valueText(fatura?.hareket_sayisi)}`);
		lines.push(`Son Hareket: ${USEFUL_LIFE_MOVEMENT_LABELS[fatura?.son_hareket] || valueText(fatura?.son_hareket)}`);
		lines.push(`Arsiv Tarihi: ${formatDate(fatura.alim_partisi_arsiv_tarihi, true)}`);
		lines.push(`Arsiv Notu: ${valueText(fatura.alim_partisi_arsiv_notu)}`);
	});
	lines.push("");

	if (totalsByCurrency.size) {
		lines.push("Fatura Toplamlari");
		[...totalsByCurrency.entries()].forEach(([currencyCode, totalAmount]) => {
			lines.push(`- ${formatFaturaAmount(tl, totalAmount, currencyCode)}`);
		});
		lines.push("");
	}

	return lines.join("\n");
}

function canManageOverviewHistory() {
	return ["admin", "kullanici"].includes(uiState.currentUser?.yetki);
}

function closeOverviewActionMenu(dialog) {
	const menu = dialog?.querySelector(".overview-action-menu");
	if (menu) menu.hidden = true;
	dialog?.querySelector(".overview-actions-toggle")?.setAttribute("aria-expanded", "false");
}

async function fetchOverviewJson(url, options) {
	const response = await fetch(url, options);
	const data = await response.json().catch(() => ({}));
	if (!response.ok) throw new Error(data?.error || "Islem tamamlanamadi.");
	return data;
}

function eventMatchesCategory(eventItem, category) {
	if (category === "all") return true;
	if (category === "alim_partileri") {
		return eventItem.snapshot?.entity_type === "alim_partisi"
			|| Array.isArray(eventItem.snapshot?.temsil_degisiklikleri);
	}
	return eventItem.kategori === category;
}

function renderOverviewEvents(dialog, category = "all") {
	const list = dialog.querySelector(".overview-event-list");
	const items = (dialog._eventItems || []).filter((item) => eventMatchesCategory(item, category));
	if (!items.length) {
		list.innerHTML = '<div class="overview-empty-state">Bu filtrede olay bulunamadi.</div>';
		return;
	}
	list.innerHTML = items.map((item) => {
		const snapshot = item.snapshot || {};
		const periodText = snapshot.yeni_bitis_tarihi
			? `${formatDate(snapshot.yeni_baslangic_tarihi)} - ${formatDate(snapshot.yeni_bitis_tarihi)}`
			: "";
		const durationText = Number(snapshot.sure_yil || 0) || Number(snapshot.sure_ay || 0)
			? `${Number(snapshot.sure_yil || 0)} y\u0131l ${Number(snapshot.sure_ay || 0)} ay`
			: "";
		const quantityChanges = Array.isArray(snapshot.temsil_degisiklikleri)
			? snapshot.temsil_degisiklikleri.map((change) =>
				`Alim partisi #${change.fatura_id}: ${change.eski_temsil_adedi} -> ${change.yeni_temsil_adedi} (Delta ${change.delta})`,
			).join(" | ")
			: "";
		return `<article class="overview-event-card" data-category="${esc(item.kategori)}">
			<div class="overview-event-card-head"><strong>${esc(item.baslik)}</strong><time>${esc(formatDate(item.zaman, true))}</time></div>
			<div class="overview-event-meta">${esc(item.aktor || "Sistem")}${item.ozet ? ` · ${esc(item.ozet)}` : ""}</div>
			${item.not ? `<p>${esc(item.not)}</p>` : ""}
			${snapshot.karar_tarihi ? `<div class="overview-event-period">Karar: ${esc(formatDate(snapshot.karar_tarihi))}</div>` : ""}
			${durationText ? `<div class="overview-event-period">S\u00fcre: ${esc(durationText)}</div>` : ""}
			${periodText ? `<div class="overview-event-period">Donem: ${esc(periodText)}</div>` : ""}
			${snapshot.temsil_adedi_snapshot != null ? `<div class="overview-event-period">Temsil snapshot: ${esc(snapshot.temsil_adedi_snapshot)}</div>` : ""}
			${quantityChanges ? `<div class="overview-event-period">${esc(quantityChanges)}</div>` : ""}
		</article>`;
	}).join("");
}

async function openOverviewEvents(demirbasId) {
	const dialog = document.getElementById("overviewEventsDialog");
	if (!dialog || !demirbasId) return;
	dialog.querySelector(".overview-events-context").textContent = demirbasId;
	dialog.querySelector(".overview-event-list").innerHTML = '<div class="overview-empty-state">Yukleniyor...</div>';
	dialog.querySelectorAll("[data-event-category]").forEach((button) => button.classList.toggle("is-active", button.dataset.eventCategory === "all"));
	dialog.showModal();
	try {
		const data = await fetchOverviewJson(`${apiBaseUrl}/demirbas/${encodeURIComponent(demirbasId)}/olaylar`);
		dialog._eventItems = data.items || [];
		renderOverviewEvents(dialog);
	} catch (error) {
		dialog.querySelector(".overview-event-list").innerHTML = `<div class="overview-empty-state overview-empty-state--error">${esc(error.message)}</div>`;
	}
}

function buildArchivedMovementHistory(movements = []) {
	if (!movements.length) {
		return '<div class="overview-archive-history-empty">Takip hareketi bulunamad\u0131.</div>';
	}
	return `<div class="overview-archive-history">
		<strong>Faydal\u0131 \u00d6m\u00fcr Hareketleri (${movements.length})</strong>
		${movements.map((movement) => {
			const duration = Number(movement.sure_yil || 0) || Number(movement.sure_ay || 0)
				? `${Number(movement.sure_yil || 0)} y\u0131l ${Number(movement.sure_ay || 0)} ay`
				: "";
			const period = movement.yeni_bitis_tarihi
				? `${formatDate(movement.yeni_baslangic_tarihi)} - ${formatDate(movement.yeni_bitis_tarihi)}`
				: "";
			return `<div class="overview-archive-history-row">
				<div><b>${esc(USEFUL_LIFE_MOVEMENT_LABELS[movement.hareket_tipi] || movement.hareket_tipi)}</b><time>${esc(formatDate(movement.created_at, true))}</time></div>
				<span>${esc(movement.yapan_adi_snapshot || "Sistem")} \u00b7 Temsil ${esc(movement.temsil_adedi_snapshot ?? "-")}</span>
				<span>Karar: ${esc(formatDate(movement.karar_tarihi))}</span>
				${duration ? `<span>S\u00fcre: ${esc(duration)}</span>` : ""}
				${period ? `<span>D\u00f6nem: ${esc(period)}</span>` : ""}
				${movement.note ? `<p>${esc(movement.note)}</p>` : ""}
			</div>`;
		}).join("")}
	</div>`;
}

async function openArchivedLots(demirbasId) {
	const dialog = document.getElementById("overviewArchivesDialog");
	if (!dialog || !demirbasId) return;
	dialog.querySelector(".overview-archives-context").textContent = demirbasId;
	dialog.querySelector(".overview-archive-list").innerHTML = '<div class="overview-empty-state">Yukleniyor...</div>';
	dialog.showModal();
	try {
		const data = await fetchOverviewJson(`${apiBaseUrl}/demirbas/${encodeURIComponent(demirbasId)}/arsivlenen-alim-partileri`);
		const items = data.items || [];
		dialog.querySelector(".overview-archive-list").innerHTML = items.length ? items.map((item) => `
			<article class="overview-archive-card">
				<div><strong>Alim partisi #${esc(item.fatura_id)}</strong><span>${esc(item.fatura_numarasi || "-")}</span></div>
				<div>Takip #${esc(item.takip_id)} · ${esc(formatFaturaQuantityDisplay(item.birim_miktar, "-"))} temsil</div>
				<div>${esc(formatDate(item.archived_at, true))} · ${esc(item.archived_by || "Sistem")}</div>
				<p>${esc(item.archive_note || "-")}</p>
				${item.fatura_pdf_path ? `<a href="${apiBaseUrl}${esc(item.fatura_pdf_path)}" target="_blank" rel="noopener">PDF Goruntule</a>` : ""}
				${buildArchivedMovementHistory(item.hareketler)}
			</article>`).join("") : '<div class="overview-empty-state">Arsivlenmis alim partisi yok.</div>';
	} catch (error) {
		dialog.querySelector(".overview-archive-list").innerHTML = `<div class="overview-empty-state overview-empty-state--error">${esc(error.message)}</div>`;
	}
}

let didBindOverviewDialog = false;

export function initOverviewDialog() {
	ensureOverviewDialog();
	const dialog = document.querySelector("#overviewDialog");
	if (!dialog || didBindOverviewDialog) return;
	didBindOverviewDialog = true;

	window.openOverviewDialog = async (demirbasId) => {
		clearOverviewDialog(dialog);
		dialog.showModal();

		showDialogOverlay(dialog, "Yukleniyor...");
		await new Promise((resolve) => setTimeout(resolve, 350));

		try {
			const archiveQuery = canManageOverviewHistory() ? "?include_archived=1" : "";
			const res = await fetch(`${apiBaseUrl}/demirbas/${encodeURIComponent(demirbasId)}${archiveQuery}`);
			if (!res.ok) throw new Error(`HTTP ${res.status}`);
			const data = await res.json();
			fillOverviewDialog(dialog, data);
		} catch (err) {
			console.error("Overview yuklenemedi:", err);
		} finally {
			hideDialogOverlay();
		}
	};

	document.body.addEventListener("click", (e) => {
		if (e.target.closest(".overview-close") || e.target.closest(".overview-close-btn")) {
			dialog.close();
			return;
		}
		if (e.target.closest(".overview-export")) {
			const exportData = dialog._overviewData;
			if (!exportData) return;
			const filename = `${valueText(exportData.demirbas_id)}-export-${formatExportFileDate()}.txt`;
			downloadTextFile(filename, buildOverviewExportText(exportData));
			closeOverviewActionMenu(dialog);
			return;
		}
		if (e.target.closest(".overview-actions-toggle")) {
			const menu = dialog.querySelector(".overview-action-menu");
			menu.hidden = !menu.hidden;
			e.target.closest(".overview-actions-toggle").setAttribute("aria-expanded", String(!menu.hidden));
			return;
		}
		if (e.target.closest(".overview-events-open")) {
			closeOverviewActionMenu(dialog);
			openOverviewEvents(dialog._overviewData?.demirbas_id);
			return;
		}
		if (e.target.closest(".overview-archives-open")) {
			closeOverviewActionMenu(dialog);
			openArchivedLots(dialog._overviewData?.demirbas_id);
			return;
		}
		const lotArchiveButton = e.target.closest(".overview-lot-archive");
		if (lotArchiveButton) {
			if (lotArchiveButton.dataset.trackingArchived !== "1") {
				const prerequisiteDialog = document.getElementById("overviewArchivePrerequisiteDialog");
				prerequisiteDialog.querySelector(".overview-prerequisite-lot-id").textContent = `#${lotArchiveButton.dataset.faturaId}`;
				prerequisiteDialog.querySelector(".overview-prerequisite-tracking-id").textContent = `#${lotArchiveButton.dataset.takipId}`;
				prerequisiteDialog.showModal();
				return;
			}
			const archiveDialog = document.getElementById("overviewLotArchiveDialog");
			archiveDialog.dataset.faturaId = lotArchiveButton.dataset.faturaId;
			archiveDialog.dataset.demirbasId = dialog._overviewData?.demirbas_id || "";
			archiveDialog.querySelector(".overview-lot-archive-context").textContent = `Alim partisi #${lotArchiveButton.dataset.faturaId} · Takip #${lotArchiveButton.dataset.takipId}`;
			archiveDialog.querySelector(".overview-lot-archive-note").value = "";
			archiveDialog.querySelector(".overview-lot-archive-error").textContent = "";
			archiveDialog.showModal();
			return;
		}
		if (e.target.closest(".overview-prerequisite-confirm")) {
			document.getElementById("overviewArchivePrerequisiteDialog")?.close();
			return;
		}
		const subdialogClose = e.target.closest(".overview-subdialog-close");
		if (subdialogClose) {
			subdialogClose.closest("dialog")?.close();
			return;
		}
		const categoryButton = e.target.closest("[data-event-category]");
		if (categoryButton) {
			const eventsDialog = categoryButton.closest("dialog");
			eventsDialog.querySelectorAll("[data-event-category]").forEach((button) => button.classList.toggle("is-active", button === categoryButton));
			renderOverviewEvents(eventsDialog, categoryButton.dataset.eventCategory);
		}
	});

	document.body.addEventListener("submit", async (event) => {
		if (!event.target.matches(".overview-lot-archive-form")) return;
		event.preventDefault();
		const archiveDialog = event.target.closest("dialog");
		const submitButton = event.target.querySelector('button[type="submit"]');
		submitButton.disabled = true;
		try {
			await fetchOverviewJson(`${apiBaseUrl}/faturalar/${archiveDialog.dataset.faturaId}/arsiv`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ note: archiveDialog.querySelector(".overview-lot-archive-note").value }),
			});
			archiveDialog.close();
			const refreshed = await fetchOverviewJson(`${apiBaseUrl}/demirbas/${encodeURIComponent(archiveDialog.dataset.demirbasId)}?include_archived=1`);
			clearOverviewDialog(dialog);
			fillOverviewDialog(dialog, refreshed);
		} catch (error) {
			archiveDialog.querySelector(".overview-lot-archive-error").textContent = error.message;
		} finally {
			submitButton.disabled = false;
		}
	});
}

function clearOverviewDialog(dialog) {
	dialog._overviewData = null;
	dialog.querySelector(".overview-title").textContent = "";
	dialog.querySelector(".overview-id").textContent = "";
	dialog.querySelector(".overview-temsil-toplam").textContent = "";
	dialog.querySelector(".overview-badge-urun-durumu").textContent = "";
	dialog.querySelector(".overview-badge-zimmet-durumu").textContent = "";
	dialog.querySelector(".overview-fatura-list").innerHTML = "";
	dialog.querySelector(".overview-fatura-count").textContent = "0";
	closeOverviewActionMenu(dialog);
	dialog.querySelector(".overview-fatura-total").hidden = true;
	dialog.querySelector(".overview-total-label").textContent = "Toplam Satin Alma Degeri";
	const totalValueEl = dialog.querySelector(".overview-total-value");
	totalValueEl.textContent = "";
	totalValueEl.classList.remove("overview-total-value--multi");
	const productImg = dialog.querySelector(".overview-product-img");
	productImg.hidden = true;
	productImg.removeAttribute("src");
	dialog.querySelector(".overview-image-placeholder").hidden = false;
	dialog.querySelector("#overview-barcode-svg").innerHTML = "";
	dialog.querySelector(".overview-barcode-value").textContent = "";
	dialog.querySelectorAll(".overview-grid-4, .overview-grid-3").forEach((el) => {
		el.innerHTML = "";
	});
}

function fillOverviewDialog(dialog, data) {
	dialog._overviewData = data;
	const { faturalar = [], ...d } = data;

	const titleEl = dialog.querySelector(".overview-title");
	const idEl = dialog.querySelector(".overview-id");
	const temsilToplamEl = dialog.querySelector(".overview-temsil-toplam");
	const urunBadgeEl = dialog.querySelector(".overview-badge-urun-durumu");
	const zimmetBadgeEl = dialog.querySelector(".overview-badge-zimmet-durumu");
	const toplamTemsilAdedi = buildTotalQuantity(faturalar);

	titleEl.textContent = `${d.marka ?? ""} ${d.model ?? ""}`.trim() || "-";
	idEl.textContent = d.demirbas_id ?? "";
	temsilToplamEl.textContent = `Toplam Temsil: ${toplamTemsilAdedi}`;
	urunBadgeEl.textContent = d.urun_durumu ?? "-";
	zimmetBadgeEl.textContent = d.zimmet_durumu ?? "-";
	titleEl.title = titleEl.textContent;
	idEl.title = idEl.textContent;
	temsilToplamEl.title = temsilToplamEl.textContent;
	urunBadgeEl.title = urunBadgeEl.textContent;
	zimmetBadgeEl.title = zimmetBadgeEl.textContent;
	dialog.querySelector(".overview-action-menu-wrap").hidden = false;
	dialog.querySelectorAll(".overview-history-action").forEach((button) => {
		button.hidden = !canManageOverviewHistory();
	});

	const img = dialog.querySelector(".overview-product-img");
	const placeholder = dialog.querySelector(".overview-image-placeholder");
	if (d.demirbas_image_path) {
		img.src = apiBaseUrl + d.demirbas_image_path;
		img.hidden = false;
		placeholder.hidden = true;
	} else {
		img.removeAttribute("src");
		img.hidden = true;
		placeholder.hidden = false;
	}

	const barcodeSvg = dialog.querySelector("#overview-barcode-svg");
	if (d.barkod) {
		JsBarcode(barcodeSvg, String(d.barkod), {
			format: "CODE128",
			lineColor: "#1d212c",
			width: 2,
			height: 55,
			displayValue: false,
			margin: 0,
		});
	}
	dialog.querySelector(".overview-barcode-value").textContent = d.barkod ?? "-";

	const sections = dialog.querySelectorAll(".overview-section");

	fillGrid(sections[0].querySelector(".overview-grid-4"), [
		["Demirbas ID", d.demirbas_id],
		["Departman", d.departman],
		["Urun Grubu", d.urun_grubu],
		["Urun Alt Grubu", d.urun_alt_grubu],
		["Urun Cinsi", d.urun_cinsi],
		["Marka / Model", `${d.marka ?? ""} / ${d.model ?? ""}`],
		["Seri No", d.seri_numarasi],
		["Aciklama", d.aciklama, 2],
	]);

	sections[1].querySelector(".overview-fatura-count").textContent = faturalar.length;
	const faturaList = sections[1].querySelector(".overview-fatura-list");
	faturaList.innerHTML = "";

	const totalsByCurrency = buildTotalsByCurrency(faturalar);
	faturalar.forEach((fatura) => {
		faturaList.insertAdjacentHTML("beforeend", buildFaturaCard(fatura));
	});

	const totalEl = sections[1].querySelector(".overview-fatura-total");
	const totalLabelEl = sections[1].querySelector(".overview-total-label");
	const totalValueEl = sections[1].querySelector(".overview-total-value");
	if (faturalar.length) {
		totalEl.hidden = false;
		if (totalsByCurrency.size === 1) {
			const [currencyCode, totalAmount] = [...totalsByCurrency.entries()][0];
			totalLabelEl.textContent = "Toplam Satin Alma Degeri";
			totalValueEl.classList.remove("overview-total-value--multi");
			totalValueEl.textContent = formatFaturaAmount(tl, totalAmount, currencyCode);
		} else {
			totalLabelEl.textContent = "Para Birimine Gore Toplamlar";
			totalValueEl.classList.add("overview-total-value--multi");
			totalValueEl.innerHTML = [...totalsByCurrency.entries()]
				.map(
					([currencyCode, totalAmount]) =>
						`<span class="overview-total-value-line">${formatFaturaAmount(tl, totalAmount, currencyCode)}</span>`,
				)
				.join("");
		}
	}

	fillGrid(sections[2].querySelector(".overview-grid-3"), [
		["Personel", d.zimmetlenen_kisi],
		["TC Kimlik No", d.zimmetlenen_tc],
		["Zimmet Tarihi", formatDate(d.zimmet_tarihi)],
	]);

	fillGrid(sections[3].querySelector(".overview-grid-3"), [
		["Lokasyon", d.lokasyon],
		["Oda", d.oda],
		["Yer", d.yer],
	]);

	fillGrid(sections[4].querySelector(".overview-grid-4"), [
		["Olusturan", d.olusturan_kullanici],
		["Olusturma Tarihi", formatDate(d.olusturma_tarihi, true)],
		["Son Guncelleyen", d.son_guncelleyen_kullanici],
		["Son Guncelleme", formatDate(d.son_guncelleme_tarihi, true)],
	]);
}

function fillGrid(container, items) {
	if (!container) return;
	container.innerHTML = items
		.map(([label, value, span]) => {
			const isScrollable = label === "Aciklama";
			return `<div class="overview-detail${span ? ` overview-detail--span-${span}` : ""}">
				<span class="overview-detail-label">${label}</span>
				<span class="overview-detail-value${isScrollable ? " overview-detail-value--scroll" : ""}" title="${esc(value ?? "-")}">${esc(value ?? "-")}</span>
			</div>`;
		})
		.join("");
}

function buildFaturaCard(fatura) {
	const kdvLabel = fatura.kdv_orani != null ? `KDV (%${fatura.kdv_orani})` : "KDV";
	const currencyCode = normalizeFaturaCurrency(fatura.para_birimi);
	const amortismanStatus = fatura.amortisman_durumu || "belirlenmedi";
	const amortismanLabel = fatura.amortisman_uygulanmaz
		? "Amortisman uygulanmaz"
		: fatura.amortisman_tanim_adi || "Belirlenmedi";
	const faydaliOmurText = fatura.faydali_omur_yil ? `${fatura.faydali_omur_yil} y\u0131l` : "-";
	const canArchiveLot = canManageOverviewHistory();
	const lotArchiveAction = canArchiveLot
		? `<button type="button" class="overview-btn overview-btn--archive overview-lot-archive" data-fatura-id="${fatura.fatura_id}" data-takip-id="${fatura.takip_id}" data-tracking-archived="${fatura.takip_arsivli ? "1" : "0"}" title="Alim partisini arsivle">Arsivle</button>`
		: "";
	const pdfActions = fatura.fatura_pdf_path
		? `<div class="overview-fatura-actions">
				<a href="${apiBaseUrl}${fatura.fatura_pdf_path}" download class="overview-btn overview-btn--outline">Indir</a>
				<a href="${apiBaseUrl}${fatura.fatura_pdf_path}" target="_blank" rel="noopener" class="overview-btn overview-btn--primary">Goruntule</a>
			</div>`
		: "";

	return `
	<div class="overview-fatura-card">
		<div class="overview-fatura-card-header">
			<div class="overview-fatura-heading">
				<span class="overview-fatura-no" title="${esc(fatura.fatura_numarasi ?? "-")}">${esc(fatura.fatura_numarasi ?? "-")}</span>
				<div class="overview-fatura-identifiers">
					<span>Al\u0131m Partisi #${esc(fatura.fatura_id)}</span>
					<span>Faydal\u0131 \u00d6m\u00fcr Takibi #${esc(fatura.takip_id)}</span>
				</div>
			</div>
			<div class="overview-fatura-header-side">
				<span class="overview-fatura-date" title="${esc(formatDate(fatura.satin_alma_tarihi))}">${esc(formatDate(fatura.satin_alma_tarihi))}</span>
				${lotArchiveAction}
			</div>
		</div>
		<div class="overview-fatura-card-body">
			<div class="overview-fatura-main-row">
				<div class="overview-fatura-desc">
					<span class="overview-detail-label">Fatura Aciklamasi</span>
					<span class="overview-detail-value--scroll" title="${esc(fatura.fatura_aciklama ?? "-")}">${esc(fatura.fatura_aciklama ?? "-")}</span>
				</div>
				<div class="overview-fatura-financials">
					<div>
						<span class="overview-detail-label">Birim Fiyat</span>
						<span>${fatura.birim_fiyat != null ? formatFaturaAmount(tl, fatura.birim_fiyat, currencyCode) : "-"}</span>
					</div>
					<div>
						<span class="overview-detail-label">Temsil Adedi</span>
						<span>${esc(formatFaturaQuantityDisplay(fatura.birim_miktar, "-"))}</span>
					</div>
					<div>
						<span class="overview-detail-label">${kdvLabel}</span>
						<span>${fatura.kdv_tutar != null ? formatFaturaAmount(tl, fatura.kdv_tutar, currencyCode) : "-"}</span>
					</div>
				</div>
				<div class="overview-fatura-total-section">
					<div class="overview-total-block">
						<span class="overview-total-label-small">Satin Alma Degeri</span>
						<span class="overview-fatura-total-val">${fatura.satin_alma_degeri != null ? formatFaturaAmount(tl, fatura.satin_alma_degeri, currencyCode) : "-"}</span>
					</div>
					${pdfActions}
				</div>
			</div>
			<div class="overview-fatura-amortisman">
				<div>
					<span class="overview-detail-label">Faydal\u0131 \u00d6m\u00fcr Tan\u0131m\u0131</span>
					<span>${esc(amortismanLabel)}</span>
				</div>
				<div>
					<span class="overview-detail-label">S\u00fcre</span>
					<span>${esc(faydaliOmurText)}</span>
				</div>
				<div>
					<span class="overview-detail-label">Tahmini Biti\u015f</span>
					<span>${esc(formatDate(fatura.amortisman_bitis_tarihi))}</span>
				</div>
				<span class="amortisman-status-badge amortisman-status-badge--${esc(amortismanStatus)}">${esc(AMORTISMAN_STATUS_LABELS[amortismanStatus] || "Belirlenmedi")}</span>
			</div>
		</div>
	</div>`;
}
